import React from "react";
import PropTypes from "prop-types";

import AanvragerForm from "./AanvragerForm";
import ContactPersoonForm from "./ContactPersoonForm";
import Fieldset from "../common/Fieldset";
import TextInput from "../common/TextInput";
import Section from "../common/Section";
import RepeatingFieldset from "../common/RepeatingFieldset";
import Form from "../common/Form";
import SelectInput from "../common/SelectInput";
import FieldsetSubHeader from "../common/FieldsetSubHeader";

const AanvraagForm = (props) => {
	const {
		aanvraag,
		disabled,
		errors,
		postcodes,
		gemeenten,
		listOfAanvragers,
		juridischeStatuten,
		onChange,
		onChangeAanvrager,
		onChangeContactpersoon,
		onAddAanvrager,
		onRemoveAanvrager,
		onAddGemandateerde,
		onRemoveGemandateerde,
		onChangeGemandateerde,
		onSave,
		color,
		validationMessageType
	} = props;

	// -- TOOLTIPS
	const DOSSIERNAAM_TOOLTIP = "Een dossiernaam bestaat uit de naam van de sportinfrastructuur. Bijvoorbeeld: S&R Olympia of Euro Volley Center. ";
	const REKENINGSNUMMER_TOOLTIP = "Dit is het rekeningnummer waarop een eventuele subsidie mag gestort worden. Een correct rekeningnummer (IBAN) in ons land heeft 16 karakters: de landcode 'BE' voor België, een controlegetal van 2 cijfers, en 12 cijfers. Bovendien is dit rekeningnummer gelinkt aan de gemandateerde en de aanvragende instantie.<br />De houder van het rekeningnummer mag geen natuurlijk persoon zijn.";
	const AANVRAGER_TOOLTIP = "Er zijn minimaal 2 contactpersonen die het eerste aanspreekpunt vormen voor Sport Vlaanderen bij vragen over het ingediende dossier. Deze personen zijn, en blijven doorheen het ganse traject, op de hoogte van het ingediende dossier. Zij krijgen ook een e-mail met een unieke code nadat het aanvraagformulier voor een eerste keer wordt opgeslagen.";

	// -- onChanges
	function mapChangeAanvrager(i) {
		return function (event, data) {
			onChangeAanvrager(event, i, data);
		};
	}

	function mapChangeContactpersoon(i) {
		return function (event, data) {
			onChangeContactpersoon(event, i, data);
		};
	}

	function mapRemoveAanvrager(i) {
		return function (event) {
			onRemoveAanvrager(event, i);
		};
	}

	// -- Repeatable CMPNT
	const aanvragersForm = aanvraag.aanvragers.map((aanvrager, i) => {
		let aanvraagErrors = null;
		if (errors != null) {
			aanvraagErrors = errors.aanvragers != undefined ? errors.aanvragers[i] : null;
		}

		const repeatingBlock = (<RepeatingFieldset
			key={i}
			onAddClick={onAddAanvrager}
			onRemoveClick={mapRemoveAanvrager(i)}
			entityName="aanvrager"
			isDisabled={disabled}
			isMinButtonEnabled={aanvraag.aanvragers.length > 1}
			isPlusButtonEnabled={aanvraag.aanvragers.length == (i + 1)}>
			<FieldsetSubHeader>Aanvrager {i + 1}</FieldsetSubHeader>
			<AanvragerForm
				aanvrager={aanvrager}
				aanvragerIndex={i}
				disabled={disabled}
				errors={aanvraagErrors}
				juridischeStatuten={juridischeStatuten}
				postcodes={postcodes}
				gemeenten={gemeenten}
				onChange={mapChangeAanvrager(i)}
				onAddGemandateerde={onAddGemandateerde}
				onRemoveGemandateerde={onRemoveGemandateerde}
				onChangeGemandateerde={onChangeGemandateerde} />
		</RepeatingFieldset>);

		return (repeatingBlock);
	});

	const aanvrager = (listOfAanvragers.length > 1
		? <SelectInput
			size={6}
			disabled={disabled}
			onChange={onChange}
			name="houderRekeningnummerAanvragerId"
			label="Houder van de rekening"
			defaultItem="Kies de houder van de rekening"
			value={aanvraag.houderRekeningnummerAanvragerId.toString()}
			items={listOfAanvragers}
			validationMessage={errors ? errors.houderRekeningnummerAanvragerId : ''} />
		: listOfAanvragers.length ? <TextInput
			size={6}
			onChange={onChange}
			disabled
			name="houderRekeningnummerAanvragerId"
			label="Houder van de rekening"
			value={listOfAanvragers[0].label}
			validationMessage={errors ? errors.houderRekeningnummerAanvragerId : ''}
			validationMessageType={validationMessageType} /> : '');

	return (
		<Section title="Vul het antwoord op onderstaande vragen in" color={color} disabled={disabled}>
			<Form
				title="Invulformulier aanvrager"
				name="aanvraag"
				rightButtonLabel="Bewaar"
				onRightButtonClick={onSave}
				rightButtonDisabled={disabled}>
				<TextInput
					label=" "
					style={{ border: '0px', width: '100px' }}
					surroundingStyle={{ position: 'absolute', left: '-999px' }}
					name="naamLeidinggevende"
					value={aanvraag.naamLeidinggevende}
					onChange={onChange}
					disabled={disabled}
					validationMessageType={validationMessageType}
				/>
				{aanvraag.version > 0 ? null :
					<Fieldset title="Dossier informatie">
						<TextInput
							label="Naam van het project"
							name="naam"
							value={aanvraag.naam}
							onChange={onChange}
							size={12}
							validationMessage={errors ? errors.naam : ''}
							disabled={disabled}
							tooltip={DOSSIERNAAM_TOOLTIP}
							maxLength={100}
							validationMessageType={validationMessageType}
						/>
					</Fieldset>}
				<Fieldset title="Identificatie van de aanvrager(s)">
					{aanvragersForm}
				</Fieldset>
				{listOfAanvragers.length > 1 ?
					<Fieldset title="Wat is de onderlinge verhouding en rolverdeling tussen de aanvragers?">
						<TextInput
							label="Onderlinge verhouding en rolverdeling aanvragers"
							name="verhoudingRolverdelingAanvragers"
							value={aanvraag.verhoudingRolverdelingAanvragers}
							onChange={onChange}
							size={12}
							disabled={disabled}
							validationMessage={errors ? errors.verhoudingRolverdelingAanvragers : ''}
							maxLength={1000}
							validationMessageType={validationMessageType}
						/>
					</Fieldset>
					: null}
				<Fieldset title="Rekeningnummer waarop de eventuele subsidie mag gestort worden"
					tooltip={REKENINGSNUMMER_TOOLTIP} tooltipWindowWidth={35}>
					<TextInput
						label="IBAN"
						name="rekeningNummer"
						value={aanvraag.rekeningNummer}
						onChange={onChange}
						size={6}
						validationMessage={errors ? errors.rekeningNummer : ''}
						disabled={disabled}
						validationMessageType={validationMessageType}
					/>
					{aanvrager}
				</Fieldset>
				<ContactPersoonForm
					contactpersoon={aanvraag.contactpersoon1}
					disabled={disabled}
					errors={errors ? errors.contactpersoon1 : null}
					title="Contactpersoon 1"
					listOfAanvragers={listOfAanvragers}
					tooltip={AANVRAGER_TOOLTIP}
					tooltipWindowWidth={35}
					tooltipWindowAlignRight={false}
					onChange={mapChangeContactpersoon(0)}
				/>
				<ContactPersoonForm
					contactpersoon={aanvraag.contactpersoon2}
					disabled={disabled}
					errors={errors ? errors.contactpersoon2 : null}
					title="Contactpersoon 2"
					listOfAanvragers={listOfAanvragers}
					onChange={mapChangeContactpersoon(1)}
				/>
			</Form>
		</Section>
	);
};

// ----------------------------------------------------------------------------
AanvraagForm.propTypes = {
	aanvraag: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	gemeenten: PropTypes.arrayOf(PropTypes.object).isRequired,
	postcodes: PropTypes.arrayOf(PropTypes.object).isRequired,
	juridischeStatuten: PropTypes.arrayOf(PropTypes.object).isRequired,
	listOfAanvragers: PropTypes.arrayOf(PropTypes.object).isRequired,
	onChange: PropTypes.func.isRequired,
	onChangeAanvrager: PropTypes.func.isRequired,
	onChangeContactpersoon: PropTypes.func.isRequired,
	onAddAanvrager: PropTypes.func.isRequired,
	onRemoveAanvrager: PropTypes.func.isRequired,
	onAddGemandateerde: PropTypes.func.isRequired,
	onRemoveGemandateerde: PropTypes.func.isRequired,
	onChangeGemandateerde: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired
};

export default AanvraagForm;
